export enum PathRoute {
  HOME = '/',
  LOGIN = '/login/:alert?',
  DASHBOARDS = '/dashboards',
  SETTINGS = '/settings',
  UPGRADE = '/upgrade',
  RECOVERY = '/recovery',
}
